import React, { useEffect, useState } from 'react';
import Wrapper from './Wrapper';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';

const StudentDetails = () => {
  const [isLoaded, setIsLoaded] = useState(false); // To track when the data is ready
  const [studentData, setStudentData] = useState(null); // To store the student data
  const { id, email } = useParams(); // Access both id and email from URL
  console.log(studentData);

  // console.log("Student ID:", id);
  // console.log("Student Email:", email);

  useEffect(() => {
    setIsLoaded(true);
    // Check if both id and email are available
    if (id && email) {
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');

      const raw = JSON.stringify({
        email: email, // Use the email from the URL params
        courseId: id // Use the id from the URL params
      });

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      fetch('https://quran-backend-theta.vercel.app/v1/user/signle-enrolled-course', requestOptions)
        .then((response) => response.json()) // Automatically parses the JSON response
        .then((data) => {
          if (data?.success === false) {
            console.log(data);

            setIsLoaded(false);
            toast.error(data?.error);
          }
          setStudentData(data);
          setIsLoaded(false);
        })
        .catch((error) => {
          console.error(error);
          toast.error(error);
          setIsLoaded(false);
        });
    }
  }, [id, email]);

  // console.log("GAME", studentData?.data?.enrollment?.nextPaymentDate);

  return (
    <Wrapper>
      <h2 className="main_title ">Student Details</h2>
      <p className=" text-[#1C1D1D]">Here are details of the Student</p>

      <div className=" p-3 mt-10 rounded-lg" style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}>
        {/* Check if the data exists and display accordingly */}
        {studentData ? (
          <>
            <div className=" flex justify-between items-center">
              <div>
                <span className=" m-0 text-gray-400 text-sm">Student Name</span>
                <h6 className=" text-lg">{studentData?.data?.enrollment?.studentName}</h6>{' '}
                {/* Assuming name field from response */}
              </div>
              <div>
                <span className=" m-0   text-gray-400 text-sm">Time</span>
                <h6 className=" text-lg">
                  {studentData?.data?.assignment?.timeSlots?.map((item, index) => {
                    return (
                      <div key={index}>
                        <p className="">
                          {item?.startTime} - {item?.endTime}
                        </p>
                      </div>
                    );
                  })}
                </h6>{' '}
                {/* Assuming time field */}
              </div>
            </div>
            <span className=" m-0 text-gray-400 text-sm">Father Name</span>
            <h6 className=" text-lg">{studentData?.data?.enrollment?.fatherName}</h6>{' '}
            {/* Assuming fatherName field */}
            <span className=" m-0 text-gray-400 text-sm">Age</span>
            <h6 className=" text-lg">{studentData?.data?.user?.age}</h6> {/* Assuming age field */}
            <span className=" m-0 text-gray-400 text-sm">Address</span>
            <h6 className=" text-lg">{studentData?.data?.user?.age}</h6>{' '}
            {/* Assuming address field */}
            <span className=" m-0 text-gray-400 text-sm">Country</span>
            <h6 className=" text-lg">{studentData?.data?.user?.country}</h6>{' '}
            {/* Assuming country field */}
            {/* Assuming address field */}
            <span className=" m-0 text-gray-400 text-sm">Password</span>
            <h6 className=" text-lg">{studentData?.data?.user?.password}</h6>{' '}
            {/* Assuming country field */}
            <span className=" m-0 text-gray-400 text-sm">Phone Number</span>
            <h6 className=" text-lg">{studentData?.data?.user?.phoneNumber}</h6>{' '}
            <span className=" m-0 text-gray-400 text-sm">Whatsapp Number</span>
            <h6 className=" text-lg">{studentData?.data?.user?.whatsappNumber}</h6>{' '}
            {/* Assuming phone field */}
            <span className=" m-0 text-gray-400 text-sm">Payment</span>
            <h6 className=" text-lg text-green">
              Due Date: {moment(studentData?.data?.enrollment?.nextPaymentDate).format('MMM Do YY')}
            </h6>{' '}
            {/* Assuming paymentDueDate field */}
          </>
        ) : (
          <div>No student data available</div> // Show a fallback if no data is available
        )}
      </div>
    </Wrapper>
  );
};

export default StudentDetails;
